import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Form } from 'react-bootstrap';
import TextError from "./TextError";

function InputFieldUsername(props) {
    const { label, name, touched, errors, formik, ...rest } = props;
    const handleInputName = (e) => {
        let value = e.target.value;
        formik.setFieldValue(name, value.toLowerCase());
    };


    return (
        <Form.Group>
            <Field
                id={name}
                name={name}
                {...rest}
                className={touched[name] && errors[name] ? "error" : null}
                onChange={(e) => handleInputName(e)}
            />
            <ErrorMessage name={name} component={TextError} />
        </Form.Group>
    )
}

export default InputFieldUsername